module.exports = true;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/$.library.js
// module id = 156
// module chunks = 0